import { normalizeString } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PSF_SHARE_INSTAGRAM_URL = createFcmConfig('psf_share_instagram_url', {
	normalizer: normalizeString,
	defaultValue: 'https://www.instagram.com/',
});
